/*
  Joyoneer cart V2 (2026-10-23).
  - Suggested item (snippets/joy-cart-upsell.liquid): a size must be chosen, then the button is
    handed to Broadcast's cart (`theme:cart:add`), which posts the form and refreshes the drawer.
  - Estimated arrival under the total: the product page's rule (5-7 business days production,
    then 6-10 business days shipping, Monday-Friday, orders after 2 PM Pacific start the next
    business day). Filled on load and after every cart change.
  - Order note: opening it scrolls the note into view above the pinned checkout area and puts
    the cursor in the box; focusing the box keeps it in view when the phone keyboard opens.
*/
(function () {
  if (window.joyCartReady) return;
  window.joyCartReady = true;

  /* ---------- Suggested item ---------- */
  function sizeError(form, on) {
    var select = form.querySelector('[data-joy-cu-select]');
    var message = form.querySelector('[data-joy-cu-error]');
    if (!select || !message) return;
    message.hidden = !on;
    if (on) {
      message.id = select.id + '-error';
      select.setAttribute('aria-invalid', 'true');
      select.setAttribute('aria-describedby', message.id);
      select.focus();
    } else {
      select.removeAttribute('aria-invalid');
      select.removeAttribute('aria-describedby');
    }
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-joy-cu-select]');
    if (!select) return;
    var form = select.closest('form');
    var id = form && form.querySelector('[data-joy-cu-id]');
    if (id) id.value = select.value;
    if (form) sizeError(form, false);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-joy-cu-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    var form = button.closest('form');
    var select = form && form.querySelector('[data-joy-cu-select]');
    if (select && !select.value) {
      sizeError(form, true);
      return;
    }
    if (window.a11y) window.a11y.lastElement = button;
    document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: button } }));
  });

  /* ---------- Estimated arrival ---------- */
  var TZ = 'America/Los_Angeles';
  var CUTOFF_HOUR = 14;

  function addBusinessDays(start, days) {
    var date = new Date(start);
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day >= 1 && day <= 5) added++;
    }
    return date;
  }

  function orderStart() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hour12: false
    }).formatToParts(new Date());
    var v = {};
    parts.forEach(function (p) { if (p.type !== 'literal') v[p.type] = parseInt(p.value, 10); });
    var start = new Date(v.year, v.month - 1, v.day);
    var day = start.getDay();
    if (day === 6) { start.setDate(start.getDate() + 2); return start; }
    if (day === 0) { start.setDate(start.getDate() + 1); return start; }
    if (v.hour >= CUTOFF_HOUR) {
      do { start.setDate(start.getDate() + 1); } while (start.getDay() === 0 || start.getDay() === 6);
    }
    return start;
  }

  function etaText() {
    var start = orderStart();
    var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    var early = addBusinessDays(addBusinessDays(start, 5), 6);
    var late = addBusinessDays(addBusinessDays(start, 7), 10);
    return fmt(early) + ' – ' + fmt(late);
  }

  function fillEta() {
    var text;
    try { text = etaText(); } catch (e) { return; }
    document.querySelectorAll('[data-joy-cart-eta]').forEach(function (row) {
      var slot = row.querySelector('[data-joy-cart-eta-date]');
      if (!slot) return;
      slot.textContent = text;
      row.hidden = false;
    });
  }

  /* ---------- Order note ---------- */
  function drawerBody(el) {
    return el.closest('[data-cart-drawer-body]');
  }

  function revealNote(details, focus) {
    var body = drawerBody(details);
    if (!body) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Wait for the theme's open animation, then bring the whole note above the pinned footer.
    setTimeout(function () {
      var box = details.getBoundingClientRect();
      var view = body.getBoundingClientRect();
      var overflow = box.bottom - view.bottom + 16;
      if (overflow > 0) body.scrollTo({ top: body.scrollTop + overflow, behavior: reduce ? 'auto' : 'smooth' });
      if (focus) {
        var field = details.querySelector('textarea');
        if (field) {
          try { field.focus({ preventScroll: true }); } catch (e) { field.focus(); }
        }
      }
    }, 320);
  }

  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details || details.tagName !== 'DETAILS' || !details.open) return;
    if (!details.closest('cart-drawer') || !details.querySelector('textarea[name="note"]')) return;
    revealNote(details, true);
  }, true);

  document.addEventListener('focusin', function (event) {
    var field = event.target;
    if (!field || field.name !== 'note' || !field.closest('cart-drawer')) return;
    var details = field.closest('details');
    // The phone keyboard shrinks the view a moment after focus.
    if (details) setTimeout(function () { revealNote(details, false); }, 250);
  });

  /* ---------- Boot + refresh ---------- */
  document.addEventListener('theme:cart:change', fillEta);
  document.addEventListener('theme:cart-drawer:open', fillEta);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillEta);
  } else {
    fillEta();
  }
})();
